const COORDINATE_REGEX = /^\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*$/;

export function normalizePointObject(item, idx) {
  const label =
    item?.label ?? item?.Label ?? item?.name ?? item?.Name ?? item?.address ?? item?.Address ?? null;
  const visitPointId = item?.visitPointId ?? item?.VisitPointId ?? null;
  const latitude = item?.latitude ?? item?.Latitude ?? null;
  const longitude = item?.longitude ?? item?.Longitude ?? null;
  const type = item?.type ?? item?.Type ?? null;
  return {
    id: item?.id ?? `interm_${idx}`,
    type,
    label,
    latitude,
    longitude,
    visitPointId,
  };
}

// Retorna os pontos intermediários NA ORDEM em que vieram do backend.
// Essa ordem é a ordem de otimização (foi a ordem gravada via createRoutePoint
// ao salvar a rota) — por isso NUNCA deve ser reordenada aqui.
export function parseIntermediatePoints(raw) {
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw.map((item, idx) => normalizePointObject(item, idx));
  }

  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map((item, idx) => normalizePointObject(item, idx));
      }
    } catch {
      // não é JSON — segue para o parser legado abaixo
    }

    return raw
      .split(";")
      .map((s) => s.trim())
      .filter(Boolean)
      .map((chunk, idx) => {
        const match = chunk.match(COORDINATE_REGEX);
        if (match) {
          return {
            id: `interm_${idx}`,
            type: null,
            label: null,
            latitude: parseFloat(match[1]),
            longitude: parseFloat(match[2]),
            visitPointId: null,
          };
        }
        return {
          id: `interm_${idx}`,
          type: null,
          label: chunk,
          latitude: null,
          longitude: null,
          visitPointId: null,
        };
      });
  }

  return [];
}
